theme.ParallaxAnimation = (function () {
  function ParallaxAnimation(container) {
    this.container = container;
    const isEnabled =
      container.getAttribute('data-parallax-enabled') === 'true';
    if (!isEnabled) return;
    this.init();
  }

  ParallaxAnimation.prototype.init = function () {
    const mainImage = this.container.querySelector('.parallax__main-image');
    const images = [
      this.container.querySelector('.parallax__image-1'),
      this.container.querySelector('.parallax__image-2'),
      this.container.querySelector('.parallax__image-3'),
      this.container.querySelector('.parallax__image-4')
    ];

    if (!mainImage && images.every((img) => img === null)) return;

    const mm = gsap.matchMedia();

    mm.add(
      { isDesktop: '(min-width: 1024px)', isMobile: '(max-width: 1023px)' },
      (context) => {
        const { isDesktop } = context.conditions;

        const parallaxConfig = isDesktop
          ? [-50, -120, -40, -60, -65]
          : [-15, -50, -20, -30, -35];

        const viewHeight = window.screen.height;
        if (mainImage) {
          gsap.to(mainImage, {
            y: parallaxConfig[0],
            ease: 'none',
            scrollTrigger: {
              trigger: mainImage,
              start: 'top bottom',
              end: `+=${viewHeight}`,
              scrub: 1.5 * 0.2
            }
          });
        }

        images.forEach((img, i) => {
          if (!img) return;
          gsap.to(img, {
            y: parallaxConfig[i + 1],
            ease: 'none',
            scrollTrigger: {
              trigger: img,
              start: 'top bottom',
              end: `+=${viewHeight}`,
              scrub: 1.5 * 0.2
            }
          });
        });
      }
    );
  };

  return ParallaxAnimation;
})();
